import { useParams } from 'react-router-dom'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { ICourseService } from '@/services/contracts/courses'

type DeleteCourseProps = {
  courseService: ICourseService
}

export function useDeleteCourse({ courseService }: DeleteCourseProps) {
  const queryClient = useQueryClient()
  const { id } = useParams()

  const { mutateAsync, isPending: isPendingDelete } = useMutation({
    mutationFn: (id: string) => courseService.delete(id),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [`list_institution`, id],
      })
    },
  })

  return {
    deleteCourse: mutateAsync,
    isPendingDelete,
  }
}
